//import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from '../models/User';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { PlatformLocation } from '@angular/common';


//const httpOptions = {
//  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
//};
@Injectable()
export class UserService {
  deleteUser(user: User): Observable<boolean> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.delete<boolean>(this.location.getBaseHrefFromDOM() + 'api/users/' + user.Id, { headers: headers });
  }



  constructor(
    private http: HttpClient, private location: PlatformLocation) { }

  getUsers(startingWith: string) {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.get<User[]>(this.location.getBaseHrefFromDOM() + (`api/allusers/${startingWith}`), { headers: headers });
  }

  addUser(user: User): Observable<any> {

    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.post(this.location.getBaseHrefFromDOM() + 'api/users', JSON.stringify(user), { headers: headers })
  }

  updateUser(user: User): Observable<any> {

    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.put(this.location.getBaseHrefFromDOM() + 'api/users', JSON.stringify(user), { headers: headers })
  }

  acceptTerms(userId: string) {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.post(this.location.getBaseHrefFromDOM() + 'api/users/accept', userId, { headers: headers })
  }

  getCurrentUser() {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.get<User>(this.location.getBaseHrefFromDOM() + 'api/users/current', { headers: headers });
  }

  getUserById(id: string) {

    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.get<User>(this.location.getBaseHrefFromDOM() + 'api/users/' + id, { headers: headers });
  }

  changePassword(resetData): Observable<boolean> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");
    return this.http.post<boolean>(this.location.getBaseHrefFromDOM() + 'api/users/changepassword', JSON.stringify(resetData), { headers: headers });
  }

  resetPassword(email): Observable<boolean> {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    return this.http.get<boolean>(this.location.getBaseHrefFromDOM() + 'api/users/resetpassword/' + encodeURIComponent(email), { headers: headers });
  }

  resetWithToken(userId, token, password): Observable<string> {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    return this.http.post<string>(this.location.getBaseHrefFromDOM() + 'api/users/reset?userid=' + userId + "&token=" + encodeURIComponent(token), JSON.stringify(password), { headers: headers });
  }

  IsEmailInUse(email: string): Observable<boolean> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    headers = headers.append("Content-Type", "application/json");
    return this.http.get<boolean>(this.location.getBaseHrefFromDOM() + 'api/users/isemailinuse/' + email, { headers: headers });
  }
}
